import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { Accordion, AccordionDetails } from "@mui/material";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Popover } from '@mui/material';
import { Link } from 'react-router-dom';
import Logos from '../images/Logos.png';
import BotaoDec from '../components/BotaoDec'
import BotaoValores from "../components/BotaoValores";
import BotaoOrientacoes from "../components/BotaoOrientacoes";
import Footer from "../components/Footer";
import GaleriaModal from "../components/GaleriaModal";
import BotaoCertidoes from "../components/BotaoCertidoes";
import axios from 'axios';

const drawerWidth = 240;

const navItems = [
    { route: '/programacao', text: 'Programação' },
    { route: '/galeria', text: 'Galeria' },
    { popover: true, text: 'Dúvidas' },
    { route: 'https://credmarcha.cnm.org.br/', text: 'Certificados XXV Marcha' },
];

const apiKey = 'd47b155c521b959e206f89235f04e2c7';
const albumIds = [
    '72177720317123192',
    '72177720317169716',
    '72177720317213439',
    '72177720317246814'
];

export default function Galeria(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [images1, setImages1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [images4, setImages4] = useState([]);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const requests = albumIds.map(async (albumId) => {
                    const response = await axios.get(`https://api.flickr.com/services/rest/?method=flickr.photosets.getPhotos&api_key=${apiKey}&photoset_id=${albumId}&per_page=10&format=json&nojsoncallback=1`);
                    return response.data.photoset.photo.map(photo => ({
                        url: `https://farm${photo.farm}.staticflickr.com/${photo.server}/${photo.id}_${photo.secret}.jpg`,
                        title: photo.title
                    }));
                });

                const [
                    images1,
                    images2,
                    images3,
                    images4
                ] = await Promise.all(requests);

                setImages1(images1);
                setImages2(images2);
                setImages3(images3);
                setImages4(images4);
            } catch (error) {
                console.error('Erro ao carregar imagens do Flickr:', error);
            }
        };

        fetchImages();
    });

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handlePopoverOpen = (event) => {
        setPopoverAnchor(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
    };

    const container = window !== undefined ? () => window().document.body : undefined;


    return (
        <Grid height={'100vh'}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    component="nav"
                    sx={{
                        backgroundColor: '#002758',
                        borderBottom: 0,
                        boxShadow: 'none',
                        position: 'static'
                    }}
                >
                    <Toolbar
                        sx={{
                            // display: 'flex',
                            // justifyContent: 'center',
                            // alignItems: 'center',
                            height: '18vh',
                            margin: '0 5% 0 5%',
                        }}
                    >
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon /> MENU
                        </IconButton>

                        <Box sx={{ display: { xs: 'inline', sm: 'none' }, marginRight: 'auto' }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '200px' }} />
                            </Link>
                        </Box>
                        <Grid sx={{ flexGrow: 1, display: { xs: 'none', sm: 'inline' } }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '50%' }} />
                            </Link>
                        </Grid>

                        <Box sx={{ display: { xs: 'none', md: 'inline', sm: 'inline' } }}>
                            {navItems.map((item, index) => {
                                if (!item.popover) {
                                    return (
                                        <Button
                                            key={item.text}
                                            sx={{
                                                color: '#fff',
                                                fontSize: { xl: '1rem', lg: '0.8rem' },
                                                textTransform: 'none',
                                                ...(index === navItems.length - 1 && {
                                                    backgroundColor: '#FFBE00',
                                                    color: 'success.contrastText',
                                                    borderRadius: '11px',
                                                    paddingX: '15px',
                                                }),
                                            }}
                                            component={Link}
                                            to={item.route}
                                            target={index === navItems.length - 1 ? '_blank' : undefined}
                                            rel={index === navItems.length - 1 ? 'noopener noreferrer' : undefined}
                                        >
                                            {item.text}
                                        </Button>
                                    );
                                } else {
                                    return (
                                        <React.Fragment key={item.text}>
                                            <Popover
                                                id="duvidas-popover"
                                                open={Boolean(popoverAnchor)}
                                                anchorEl={popoverAnchor}
                                                onClose={handlePopoverClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <List>
                                                    <ListItem disablePadding>
                                                        <BotaoDec />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoValores />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoCertidoes />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoOrientacoes />
                                                    </ListItem>
                                                </List>
                                            </Popover>
                                            <Button
                                                aria-describedby={popoverAnchor ? 'duvidas-popover' : undefined}
                                                onClick={handlePopoverOpen}
                                                sx={{
                                                    color: '#fff',
                                                    fontSize: { xl: '1rem', lg: '0.8rem' },
                                                    textTransform: 'none',
                                                    ...(index === navItems.length - 1 && {
                                                        backgroundColor: '#FFBE00',
                                                        color: 'success.contrastText',
                                                        borderRadius: '11px',
                                                        paddingX: '15px',
                                                    }),
                                                }}
                                            >
                                                {item.text}
                                            </Button>
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </Box>

                    </Toolbar>
                </AppBar>
                <nav>
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
                            <List>
                                {navItems.map((item) => (
                                    <ListItem key={item.text} disablePadding>
                                        <ListItemButton sx={{ textAlign: 'center' }}>
                                            {item.popover ? (
                                                <Accordion>
                                                    <AccordionDetails>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <BotaoDec />
                                                            <BotaoValores />
                                                            <BotaoCertidoes />
                                                            <BotaoOrientacoes />
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ) : (
                                                <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <ListItemText primary={item.text} />
                                                </Link>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Drawer>
                </nav>
            </Box>

            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', flexDirection: 'column', height: 'auto', marginTop: '3%' }}>
                <Typography sx={{ fontWeight: 'bold', color: '#1E3B75', fontSize: '2rem', textAlign: 'center' }}>Galeria Marcha 2024</Typography>
                {/* <Grid container justifyContent="center">
                    <Grid style={{ position: 'relative', width: '95%', maxWidth: '800px', borderRadius: '16px', boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.3)' }}>
                        <div style={{ overflow: 'hidden', paddingTop: '56.25%', position: 'relative', width: '100%', borderRadius: '16px' }}>
                            <iframe
                                title="Melhores momentos Marcha 2023"
                                style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', borderRadius: '16px' }}
                                src="https://www.youtube.com/embed/Rr91SiQW5FY"
                                frameBorder="0"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Grid>
                </Grid> */}

                <Grid sx={{ display: 'flex', justifyContent: 'space-between', gap: 4, flexWrap: 'wrap', marginTop: '3%' }}>
                    <GaleriaModal images={images1.map(image => ({ url: image.url }))} diaDoEvento="1º Dia" imageUrl="https://infonet.com.br/wp-content/uploads/2019/04/macha_prefeitos_brasilia_foto_cnm_11042019.jpg" />
                    <GaleriaModal images={images2.map(image => ({ url: image.url }))} diaDoEvento="2º Dia" imageUrl="https://www.jornalopoder.com.br/public/storage/arqConteudo/arqSiteNoticia/whatsapp-image-2024-05-21-at-15.16.53-1--1716315594664ce5cabc73c.jpeg"/>
                    <GaleriaModal images={images3.map(image => ({ url: image.url }))} diaDoEvento="3º Dia" imageUrl="https://altamira.pa.gov.br/wp-content/uploads/2023/03/52780523088_78666c9a67_b.jpg" /> 
                    <GaleriaModal images={images4.map(image => ({ url: image.url }))} diaDoEvento="4º Dia" imageUrl="https://www.cnm.org.br/cms/images/stories/comunicacao_novo/marcha/05052016_marcha_antiga_ag._cnm.jpg" /> 
                </Grid>
            </Grid>
            <Grid marginTop="5%">
                <Footer />
            </Grid>
        </Grid>
    )
}
